import type { Doctor } from '@/types/doctor-v2';

import clinicsData from '@/generated/clinics.json';

const allClinics: Doctor[] = clinicsData as Doctor[];

export function getClinicsList(): Doctor[] {
  return allClinics;
}
